import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    borderColor: '#D9D9D9',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      width: '183px',
      backgroundColor: '#fafafa',
    },
  },
  input: {
    backgroundColor: '#fafafa',
    textAlign: 'center',
    border: '2px solid #e7e7e2',
    padding: '10px',
    borderRadius: 6,
    width: '100%',
    [theme.breakpoints.down('md')]: {
      borderColor: 'inherit',
      backgroundColor: 'inherit',
      borderRadius: 4,
      transition: 'border-color 0.3s',
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    '&:focus-visible': {
      outlineColor: theme.palette.secondary.main,
    },
    '&::placeholder': {
      textAlign: 'center',
      color: '#9a9a96',
      opacity: 1,
    },
    '&:focus::placeholder': {
      color: 'transparent',
    },
  },
  icon: {
    transform: 'scale(1.5)',
    backgroundColor: 'white',
    color: 'rgb(123, 86, 155)',
    margin: '10px 15px',
    cursor: 'pointer',
    '&.checked': {
      color: '#D9D9D9',
    },
  },
}));

export const AmountSubtitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: 10,
  },
  '&&': {
    color: '#797979',
  },
}));
